'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _login = require('./login.html');

var _login2 = _interopRequireDefault(_login);

var _login3 = require('./login.controller');

var _login4 = _interopRequireDefault(_login3);

require('./login.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginComponent = {
  restrict: 'E',
  bindings: {},
  template: _login2.default,
  controller: _login4.default,
  controllerAs: 'vm'
};

exports.default = loginComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/login/login.component.js
 **/